import unescapedText from 'I18n/utils/unescapedText';
// TODO: Handle errors, like network errors, etc.
export const getVariantName = asset => asset !== null && asset !== void 0 && asset.status ? unescapedText(`personalizationLib.variantSelect.options.${asset.status}`, {
  name: asset.name
}) : asset === null || asset === void 0 ? void 0 : asset.name;